import React from 'react';
import { Card, Tooltip } from 'antd';
import { DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import { useSelector } from 'react-redux';
import { Kanban } from '../Kanban/Kanban.jsx';
import { canEditVacancyRequest } from '../../utils/vacancyRequestPermissions';

const KanbanView = ({
  requests,
  loading,
  onStatusChange,
  onViewRequest,
  onEditRequest,
  onDelete,
  vacancies,
  organisations,
  users,
  STATUSES,
  selectedStatuses
}) => {
  const { user, role } = useSelector((state) => state.auth);
  const userId = user?.id;

  const requiresCommentForEdit = (status) => {
    return ['pending', 'new', 'in_progress'].includes(status);
  };

  // Статусы, которые запрещают редактирование
  const isEditDisabled = (request) => {
    // Проверяем статусы, которые точно блокируют редактирование
    if (['closed', 'archived', 'withdrawn'].includes(request.status)) {
      return true;
    }
    // Проверяем права доступа пользователя
    return !canEditVacancyRequest(role, userId, {
      authorId: request.author,
      approverHrId: request.approver_hr_id
    });
  };


  const getOrgName = (id) => {
    if (!organisations || !Array.isArray(organisations)) return 'Не указано';
    const org = organisations.find(o => o.organisation_id === id);
    return org ? org.name : 'Не указано';
  };

  const getDeptName = (id) => {
    if (!organisations || !Array.isArray(organisations)) return 'Не указано';

    // Ищем отдел среди всех организаций
    for (const org of organisations) {
      if (org.departments && Array.isArray(org.departments)) {
        const dept = org.departments.find(d => d.id === id);
        if (dept) {
          return dept.name;
        }
      }
    }
    return 'Не указано';
  };

  const getUserName = (id) => {
    if (!users || !Array.isArray(users)) return 'Не указано';
    const user = users.find(u => u.id === id);
    return user ? `${user.first_name} ${user.last_name}` : 'Не указано';
  };

  const renderCard = (request) => (
    <Card
      key={request.id}
      size="small"
      style={{
        marginBottom: '6px',
        fontSize: '12px'
      }}
      bodyStyle={{ padding: '8px' }}
      actions={[
        <Tooltip title="Просмотреть заявку">
          <EyeOutlined key="view" onClick={() => onViewRequest(request)} />
        </Tooltip>,
        <Tooltip title={
          isEditDisabled(request)
            ? "Редактирование недоступно: недостаточно прав или заявка закрыта/архивирована/отозвана"
            : requiresCommentForEdit(request.status)
              ? "Редактировать заявку (требуется комментарий)"
              : "Редактировать заявку"
        }>
          <EditOutlined
            key="edit"
            onClick={() => !isEditDisabled(request) && onEditRequest(request)}
            style={{
              color: isEditDisabled(request)
                ? '#d9d9d9'
                : requiresCommentForEdit(request.status)
                  ? '#1890ff'
                  : undefined,
              cursor: isEditDisabled(request) ? 'not-allowed' : 'pointer'
            }}
          />
        </Tooltip>,
        // <Tooltip title="Удалить заявку">
        //   <DeleteOutlined key="delete" onClick={() => onDelete(request.id)} />
        // </Tooltip>
      ]}
    >
      <p style={{ margin: '2px 0', fontSize: '11px' }}>ID: {request.id}</p>
      <p style={{ margin: '2px 0', fontSize: '11px', fontWeight: 'bold' }}>{request.job_title}</p>
      <p style={{ margin: '2px 0', fontSize: '10px', color: '#666' }}>{getOrgName(request.organisation)}</p>
      <p style={{ margin: '2px 0', fontSize: '10px', color: '#666' }}>{getDeptName(request.department)}</p>
      <p style={{ margin: '2px 0', fontSize: '10px' }}>Автор: {getUserName(request.author)}</p>
      <p style={{ margin: '2px 0', fontSize: '10px' }}>Исполнитель: {getUserName(request.assignee_id)}</p>
    </Card>
  );

  const handleDragEnd = async (item, newStatus, newIndex) => {
    try {
      await onStatusChange(item, newStatus, newIndex);
    } catch (error) {
      console.error('Ошибка при смене статуса:', error);
    }
  };

  const filteredStatuses = Object.keys(STATUSES).reduce((acc, key) => {
    if (selectedStatuses.includes(key)) {
      acc[key] = STATUSES[key];
    }
    return acc;
  }, {});

  return (
    <Kanban
      items={requests}
      columns={filteredStatuses}
      onDragEnd={handleDragEnd}
      renderCard={renderCard}
      disabled={true}
      draggable={false}
    />
  );
};

export default KanbanView;